import React from "react";
import styled from "styled-components";
import { Timeline_Detail } from "./Timeline_Detail";
import { read_timeline_title, read_timeline_value_label } from "../../utils/timeline/timeline_formatting";

const TimelineClientLink = styled.div`
    display: grid;
    gap: 0.6rem;
    min-width: 0;

    h5 {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
    }
`;

export default function Timeline_Client_Link(props) {
    const dif = read_timeline_value_label(props.event?.data?.dif || props.event?.to?.difCode || props.event?.to?.code || props.event?.from?.difCode || props.event?.from?.code, "");
    const standalone = ["CLIENT_CREATED", "CLIENT_LINKED", "CLIENT_UNLINKED"].includes(props.event?.type);

    return (
        <TimelineClientLink>
            {standalone ? (
                <h5>{read_timeline_title(props.event, props.t)}{dif ? <span> · {dif}</span> : null}</h5>
            ) : (
                <Timeline_Detail label={props.t("DIF code")} value={dif}></Timeline_Detail>
            )}
        </TimelineClientLink>
    );
}

export { Timeline_Client_Link };
